import { render, staticRenderFns } from "./Congratulation.vue?vue&type=template&id=1f96315a&"
import script from "./Congratulation.vue?vue&type=script&lang=js&"
export * from "./Congratulation.vue?vue&type=script&lang=js&"
import style0 from "./Congratulation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports